// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../shared/images/Chat/telegram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../../shared/images/Chat/viber.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../../shared/images/Chat/vk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./../../shared/images/Chat/widget.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./../../shared/images/Chat/facebook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./../../shared/images/Chat/wechat.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./../../shared/images/Chat/instagram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./../../shared/images/Chat/uniformwidget.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./../../shared/images/Chat/whatsapp-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./../../shared/images/Chat/telegram_private.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./../../shared/images/Chat/sendPulse.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-item {
    width: 7.2rem;
    height: 5.4rem;
    margin-top: 0.4rem;
    margin-bottom: 0.4rem;
    margin-left: 0.4rem;
}

.chat-panel__chat-item__image {
    height: 100%;
    width: 100%;
}

.chat-panel__chat-item__count {
    position: relative;
    top: -6.8rem;
    left: 3.6rem;
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 50%;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 1.8rem;
    padding: 0;
    margin: 0;
    color: #ffffff;
}

.chat-panel__not-answered-messages-count-chat-with-not-answered-messages {
    background-color: #d22e37;
}

.chat-panel__not-answered-messages-count-withme-chat {
    background-color: #d6ac17;
}

.chat-panel__not-answered-messages-count-chat-without-not-answered-messages {
    background-color: #26a69a;
}

.chat-panel__chat-item__chat-id {
    position: relative;
    top: -4.5rem;
    font-size: smaller;
    font-style: italic;
    font-weight: 700;
    color: crimson;
    text-shadow: -1px 1px 0 #fff,
                1px 1px 0 #fff,
                1px -1px 0 #fff,
                -1px -1px 0 #fff;
}

.chat-panel__selected-chat{
    background-color: rgb(133, 133, 133);
}

.channel-type-telegram img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 55px;
    height: 55px;
}

.channel-type-viber img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    width: 57px;
    height: 57px;
}

.channel-type-vk img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    width: 55px;
    height: 55px;
}

.channel-type-widget img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    width: 60px;
    height: 60px;
}

.channel-type-facebook img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    width: 55px;
    height: 55px;
}

.channel-type-wechat img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    width: 58px;
    height: 58px;
}

.channel-type-instagram img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    width: 55px;
    height: 55px;
}

.channel-type-uniformwidget img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    width: 55px;
    height: 55px;
}

.channel-type-ednawhatsapp img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    width: 52px;
    height: 52px;
}

.channel-type-whatsapp img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    width: 52px;
    height: 52px;
}

.channel-type-telegram-private img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    width: 55px;
    height: 55px;
}

.channel-type-sendpulse img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    width: 55px;
    height: 55px;
}`, "",{"version":3,"sources":["webpack://./src/app/chats-panel/chat-item/ChatItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd;;;gCAG4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gDAAuD;IACvD,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAAoD;IACpD,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAAiD;IACjD,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAAqD;IACrD,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAAuD;IACvD,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAAqD;IACrD,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAAwD;IACxD,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAA4D;IAC5D,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAA4D;IAC5D,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAA4D;IAC5D,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gDAA+D;IAC/D,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iDAAwD;IACxD,WAAW;IACX,YAAY;AAChB","sourcesContent":[".chat-item {\r\n    width: 7.2rem;\r\n    height: 5.4rem;\r\n    margin-top: 0.4rem;\r\n    margin-bottom: 0.4rem;\r\n    margin-left: 0.4rem;\r\n}\r\n\r\n.chat-panel__chat-item__image {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.chat-panel__chat-item__count {\r\n    position: relative;\r\n    top: -6.8rem;\r\n    left: 3.6rem;\r\n    width: 1.8rem;\r\n    height: 1.8rem;\r\n    border-radius: 50%;\r\n    font-size: 1.1rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    line-height: 1.8rem;\r\n    padding: 0;\r\n    margin: 0;\r\n    color: #ffffff;\r\n}\r\n\r\n.chat-panel__not-answered-messages-count-chat-with-not-answered-messages {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.chat-panel__not-answered-messages-count-withme-chat {\r\n    background-color: #d6ac17;\r\n}\r\n\r\n.chat-panel__not-answered-messages-count-chat-without-not-answered-messages {\r\n    background-color: #26a69a;\r\n}\r\n\r\n.chat-panel__chat-item__chat-id {\r\n    position: relative;\r\n    top: -4.5rem;\r\n    font-size: smaller;\r\n    font-style: italic;\r\n    font-weight: 700;\r\n    color: crimson;\r\n    text-shadow: -1px 1px 0 #fff,\r\n                1px 1px 0 #fff,\r\n                1px -1px 0 #fff,\r\n                -1px -1px 0 #fff;\r\n}\r\n\r\n.chat-panel__selected-chat{\r\n    background-color: rgb(133, 133, 133);\r\n}\r\n\r\n.channel-type-telegram img {\r\n    content: url(\"./../../shared/images/Chat/telegram.svg\");\r\n    width: 55px;\r\n    height: 55px;\r\n}\r\n\r\n.channel-type-viber img {\r\n    content: url(\"./../../shared/images/Chat/viber.svg\");\r\n    width: 57px;\r\n    height: 57px;\r\n}\r\n\r\n.channel-type-vk img {\r\n    content: url(\"./../../shared/images/Chat/vk.svg\");\r\n    width: 55px;\r\n    height: 55px;\r\n}\r\n\r\n.channel-type-widget img {\r\n    content: url(\"./../../shared/images/Chat/widget.svg\");\r\n    width: 60px;\r\n    height: 60px;\r\n}\r\n\r\n.channel-type-facebook img {\r\n    content: url(\"./../../shared/images/Chat/facebook.svg\");\r\n    width: 55px;\r\n    height: 55px;\r\n}\r\n\r\n.channel-type-wechat img {\r\n    content: url(\"./../../shared/images/Chat/wechat.svg\");\r\n    width: 58px;\r\n    height: 58px;\r\n}\r\n\r\n.channel-type-instagram img {\r\n    content: url(\"./../../shared/images/Chat/instagram.svg\");\r\n    width: 55px;\r\n    height: 55px;\r\n}\r\n\r\n.channel-type-uniformwidget img {\r\n    content: url(\"./../../shared/images/Chat/uniformwidget.svg\");\r\n    width: 55px;\r\n    height: 55px;\r\n}\r\n\r\n.channel-type-ednawhatsapp img {\r\n    content: url(\"./../../shared/images/Chat/whatsapp-logo.svg\");\r\n    width: 52px;\r\n    height: 52px;\r\n}\r\n\r\n.channel-type-whatsapp img {\r\n    content: url(\"./../../shared/images/Chat/whatsapp-logo.svg\");\r\n    width: 52px;\r\n    height: 52px;\r\n}\r\n\r\n.channel-type-telegram-private img {\r\n    content: url(\"./../../shared/images/Chat/telegram_private.svg\");\r\n    width: 55px;\r\n    height: 55px;\r\n}\r\n\r\n.channel-type-sendpulse img {\r\n    content: url(\"./../../shared/images/Chat/sendPulse.svg\");\r\n    width: 55px;\r\n    height: 55px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
